import { useChart } from '../components/Chart/ChartProvider';
import type { PositionedItem } from '../components/PageConfigProvider/types/item';
import { usePageState } from '../components/PageState/PageStateProvider';
import { getRevelioPageOverrides } from '../utils/getRevelioPageOverrides';

export const usePlotMetric = () => {
  const { pageState } = usePageState();
  const { item } = useChart();

  const id = item?.id;
  const { defaultMetric } = getRevelioPageOverrides(item);
  const overriddenMetric = pageState.metricOverrides?.[id];
  return overriddenMetric ?? defaultMetric;
};

export const usePlotMetricFromItem = (item: PositionedItem | undefined) => {
  const { pageState } = usePageState();
  const id = item?.id;
  if (!id) return undefined;
  const { defaultMetric } = getRevelioPageOverrides(item);
  const overriddenMetric = pageState.metricOverrides?.[id];
  return overriddenMetric ?? defaultMetric ?? undefined;
};
